module.exports = __webpack_public_path__ + "img/introduce.38e46870.jpeg";